export default "__VITE_ASSET__CHPpFCL8__"